import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const BridgeToFeaturesSection = () => {
  return (
    <section className="py-16 lg:py-20">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-6">
          Thriving at Home Doesn't Happen by Accident
        </h2>
        
        <div className="space-y-4 text-muted-foreground text-base lg:text-lg leading-relaxed mb-4">
          <p>
            Thriving at home works best when wellness, home safety, and support work together,
            not as separate tools, but as one connected experience.
          </p>
          <p>
            SeniorThrive brings these pieces together quietly in the background, so daily life
            feels easier, safer, and more confident, without turning your home into a clinic
            or your life into a checklist.
          </p>
        </div>

        <p className="text-muted-foreground/80 text-sm lg:text-base leading-relaxed mb-8">
          Behind the scenes, SeniorThrive works as a Home Operating System, helping you stay
          aware, prevent problems early, and stay connected to the people you trust.
        </p>

        <Button
          size="lg"
          variant="outline"
          className="group"
          asChild
        >
          <Link to="/features" className="flex items-center gap-2">
            See How It Works
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default BridgeToFeaturesSection;
